<template>
	<div class="flex-y min-h-dvh">
		<v-slim-header />

		<slot></slot>

		<v-footer class="mt-auto" />

		<LazyIdleVToastContainer hydrate-on-idle />

		<client-only>
			<lazy-v-gtm-popup-wrapper />
		</client-only>
	</div>
</template>

<script lang="ts" setup>
import {useDefaultDynamicHead} from "@pkg/shared/composables/use-default-dynamic-head";

useDefaultDynamicHead();
</script>
